module.exports = __webpack_public_path__ + "static/diego-rosa-zPtNrEv3xN4-unsplash-3b56dee3a08d41e905e37f4cc7d9082f.png";